import data from "../data";

function Ref() {
    return (
        <section id="references">
          <h2 id="sectionHead">References</h2>
          {
              data.references.map(
                  i => (
                    <div class="cards">
                        <div class="card">
                            <img src="" alt="" srcset=""/>
                            <p id="referName">{i.name}</p>
                            <p id="referEmail"><a href={"mailto:"+i.email}>{i.email}</a></p>
                            <p id="referContact">{i.phone}</p>
                            <p id="referOrganization">{i.company}</p>
                            <p id="referPosition">{i.position}</p>
                        </div>
                    </div>
                  )
              )
          }
      </section>
    );
  }
  
  export default Ref;
  